
const conUndsc = (...strings) => {
  return strings.join('_');
};

const QUANTIFIER = (METHOD) => {
  return {
    SINGLE: (model) => conUndsc(METHOD, 'SINGLE', model),
    MULTIPLE: (model) => conUndsc(METHOD, 'MULTIPLE', model),
    ALL: (model) => conUndsc(METHOD, 'ALL', model),
  };
};

export const Action = {
  GET    : { ...QUANTIFIER('GET'   ) },
  FETCH  : { ...QUANTIFIER('FETCH' ) },
  SET    : { ...QUANTIFIER('SET'   ) },
  INSERT : { ...QUANTIFIER('INSERT') },
  UPDATE : { ...QUANTIFIER('UPDATE') },
  DELETE : { ...QUANTIFIER('DELETE') },
};

/**
 * Update the obj by newObj by mutating the properties 
 */
export const updateMutatable = (obj, newObj) => {
  Object.keys(newObj).map(k => {
    obj[k] = newObj[k];
  });
};